var _desc, _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDebitCard(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "48px",
    height: "48px",
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "debito") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "debito"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-59-Copy"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24,47.5 C36.9786916,47.5 47.5,36.9786916 47.5,24 C47.5,11.0213084 36.9786916,0.5 24,0.5 C11.0213084,0.5 0.5,11.0213084 0.5,24 C0.5,36.9786916 11.0213084,47.5 24,47.5 Z",
    id: "Oval-Copy",
    stroke: "#EEEEEE"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-Copy-2",
    transform: "translate(14.000000, 24.000000)",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0.5 C0,0.223637961 0.225138652,0 0.5,0 L3.5,0 C3.77683817,0 4,0.221660808 4,0.5 C4,0.775922671 3.77442205,1 3.5,1 L0.5,1 C0.223161825,1 0,0.777899824 0,0.5",
    id: "Fill-10"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5,0.5 C5,0.223637961 5.22513865,0 5.5,0 L8.5,0 C8.77639888,0 9,0.221660808 9,0.5 C9,0.775922671 8.77442205,1 8.5,1 L5.5,1 C5.22316183,1 5,0.777899824 5,0.5",
    id: "Fill-11"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10,0.5 C10,0.223637961 10.2255779,0 10.5,0 L13.5,0 C13.7763989,0 14,0.221660808 14,0.5 C14,0.775922671 13.7744221,1 13.5,1 L10.5,1 C10.2231618,1 10,0.777899824 10,0.5",
    id: "Fill-12"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16,0.5 C16,0.223637961 16.2255779,0 16.5,0 L19.5,0 C19.7768382,0 20,0.221660808 20,0.5 C20,0.775922671 19.7744221,1 19.5,1 L16.5,1 C16.2231618,1 16,0.777899824 16,0.5",
    id: "Fill-13"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "TD",
    transform: "translate(12.000000, 16.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,1.52380952 C0,0.669933968 0.699269446,0 1.56521739,0 L22.4347826,0 C23.2993554,0 24,0.671910822 24,1.52380952 L24,14.4761905 C24,15.3291874 23.3011889,16 22.4347826,16 L1.56521739,16 C0.701102994,16 0,15.3276499 0,14.4761905 L0,1.52380952 Z",
    id: "Fill-4",
    fill: "#5697FA"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-6",
    fill: "#0864EE",
    points: "2 6 6 6 6 3 2 3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2,13.5 C2,13.223638 2.22316428,13 2.5,13 L11.5,13 C11.7766161,13 12,13.2216608 12,13.5 C12,13.7759227 11.7774947,14 11.5,14 L2.5,14 C2.22360358,14 2,13.7778998 2,13.5",
    id: "Fill-8",
    fill: "#0864EE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2,11.5 C2,11.2235397 2.24624333,11 2.55172414,11 L9.44827586,11 C9.75327193,11 10,11.2215635 10,11.5 C10,11.7755819 9.75375667,12 9.44827586,12 L2.55172414,12 C2.24672807,12 2,11.7775582 2,11.5",
    id: "Fill-9",
    fill: "#0864EE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2,8.5 C2,8.22363796 2.22513865,8 2.5,8 L5.5,8 C5.77683817,8 6,8.22166081 6,8.5 C6,8.77592267 5.77442205,9 5.5,9 L2.5,9 C2.22316183,9 2,8.77789982 2,8.5",
    id: "Fill-10",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7,8.5 C7,8.22363796 7.22513865,8 7.5,8 L10.5,8 C10.7763989,8 11,8.22166081 11,8.5 C11,8.77592267 10.7744221,9 10.5,9 L7.5,9 C7.22316183,9 7,8.77789982 7,8.5",
    id: "Fill-11",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12,8.5 C12,8.22363796 12.2255779,8 12.5,8 L15.5,8 C15.7763989,8 16,8.22166081 16,8.5 C16,8.77592267 15.7744221,9 15.5,9 L12.5,9 C12.2231618,9 12,8.77789982 12,8.5",
    id: "Fill-12",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17,8.5 C17,8.22363796 17.2255779,8 17.5,8 L20.5,8 C20.7768382,8 21,8.22166081 21,8.5 C21,8.77592267 20.7744221,9 20.5,9 L17.5,9 C17.2231618,9 17,8.77789982 17,8.5",
    id: "Fill-13",
    fill: "#FFFFFF"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDebitCard);
export default __webpack_public_path__ + "static/media/debit-card.2443964b0501158134832903b97e59ce.svg";
export { ForwardRef as ReactComponent };